<template>
  <v-dialog v-model="show" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-col class="text-right pa-0">
          <v-btn
            icon
            @click="close"
            id="document_type_create__cerrar_ventana__button"
          >
            <v-icon>{{ icon.close }}</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <document-type-form
          v-model="value"
          @onCreate="onCreate"
          @onUpdate="onUpdate"
        >
        </document-type-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js'
import DocumentTypeForm from '@/modules/catalogs/components/DocumentTypeForm'

export default {
  name: 'DocumentTypeDialogForm',
  components: {
    DocumentTypeForm
  },
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      icon: {
        close: mdiClose
      },
      show: true
    }
  },
  methods: {
    close() {
      this.$emit('onClose')
    },
    onCreate(data) {
      this.$emit('onCreate', data)
    },
    onUpdate(data) {
      this.$emit('onUpdate', data)
    }
  }
}
</script>
